import React from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../components/UI/Text";
import { useCountdown } from "../../../hooks/useCurrentTime";

export interface CountdownIndicatorProps {
  className?: string;
  title: string;
  date: number | Date;
  format?: (now: number | Date, date: number | Date) => string;
  onComplete?: () => void;
}

export function SupCountdownIndicator({ className, title, date, format, onComplete }: CountdownIndicatorProps) {
  const time = useCountdown(date, { format, onComplete });

  return (
    <span className={twMerge("inline-flex p-2 gap-2 bg-neutral-800 text-neutral-25", className)}>
      <SupText variant="button">{title}</SupText>
      <SupText variant="button" weight="bold">
        {time}
      </SupText>
    </span>
  );
}
